interface SelectableOptionProps {
  children: React.ReactNode;
  value: string;
  isSelected: boolean;
  onToggle: (value: string) => void;
}

export const SelectableOption = ({
  children,
  value,
  isSelected,
  onToggle,
}: SelectableOptionProps) => {
  const handleClick = () => {
    onToggle(value);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`vai-text-sm vai-px-3 vai-py-2 vai-rounded-md vai-border vai-transition-colors vai-cursor-pointer vai-select-none ${
        isSelected
          ? 'vai-bg-blue-50 vai-border-blue-200 vai-text-blue-900 hover:vai-bg-blue-100 hover:vai-border-blue-300'
          : 'vai-bg-white vai-border-gray-200 vai-text-muted-foreground hover:vai-bg-gray-50 hover:vai-border-gray-300'
      }`}
      data-testid={`feedback-option-${value}`}
      data-selected={isSelected}
    >
      {children}
    </button>
  );
};
